var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data.length === 0)?_c('div',{staticClass:"notfound"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),_c('div',[_c('VueApexCharts',{ref:_vm.s,attrs:{"id":"chart","name":_vm.name}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }